import { useState } from 'react'
import Loader from '../../../../components/Loader.jsx';

function Leaderboard() {
    const [isLoading, setIsLoading] = useState(true);

    return (
        <div className='w-full h-full'>
            {isLoading && (
                <div className="flex justify-center flex-col items-center h-[calc(100vh-100px)]">
                    <Loader />
                </div>
            )}
            <iframe
                src="https://invest.upforex.com/en/external/1/copy/leaderboard?theme=light"
                title="Leaderboard"
                onLoad={() => setIsLoading(false)}
                style={{ width: '100%', height: 'calc(100vh - 100px)', border: 'none', display: isLoading ? 'none' : 'block' }}
            />
        </div>
    )
}

export default Leaderboard
